import {ClientService} from '@simpleinvest/ms-client-sdk';
// eslint-disable-next-line import/no-cycle
import {apiKey, getLogger} from '@client/services/sdk';
// eslint-disable-next-line import/no-cycle
import {
  requestInterceptorFulfilledHandler,
  requestInterceptorRejectedHandler,
  responseInterceptorFulfilledHandler,
  responseInterceptorRejectedHandler,
} from '@client/interceptors';
// eslint-disable-next-line import/no-cycle
import bffApi, {BffResponse} from '@client/bffApi';
import {AxiosResponse} from 'axios';
import {SourcePlatform} from '@simpleinvest/ms-core-sdk';
import {ApplicationSettingsReponse, OnboardingStatusResponse} from './response/ServiceResponse';

interface CdoSettingsParams {
  clUserId: string;
}

export default {
  getClientServiceInstance(): ClientService {
    return new ClientService({
      apiKey,
      sourceInfo: {platform: SourcePlatform.ClientPlatform},
      interceptors: {
        requestInterceptor: requestInterceptorFulfilledHandler,
        requestRejectedInterceptor: requestInterceptorRejectedHandler,
        responseInterceptor: responseInterceptorFulfilledHandler,
        responseRejectedInterceptor: responseInterceptorRejectedHandler,
      },
      logger: getLogger(),
    });
  },
  async getCdoSettings({clUserId}: CdoSettingsParams): Promise<unknown> {
    const service: ClientService = await this.getClientServiceInstance();

    return service.getCdoSettingsForClUserId({clUserId});
  },
  getAppSettings({url}): Promise<AxiosResponse<BffResponse<ApplicationSettingsReponse>>> {
    return bffApi
      .getAxiosInstance()
      .get<BffResponse<ApplicationSettingsReponse>>(`${bffApi.getBaseUrl(true)}/application/settings?domain=${url}`);
  },
  async getOnboardingStatus(
    riaId: number,
    linkAlias: string
  ): Promise<AxiosResponse<BffResponse<OnboardingStatusResponse>>> {
    const result = await bffApi
      .getAxiosInstance()
      .get<BffResponse<OnboardingStatusResponse>>(
        `${bffApi.getBaseUrl(true)}/client-onboarding/status?riaId=${riaId}&linkAlias=${linkAlias}`
      );

    return result;
  },
  sendEmailFromClientToAdviser(
    {clUserId, riaUserId, templateName},
    fields = {}
  ): Promise<AxiosResponse<BffResponse<void>>> {
    const payload = {
      overWriteFields: {...fields},
    };

    return bffApi
      .getAxiosInstance()
      .post<BffResponse<void>>(
        `${bffApi.getBaseUrl(
          true
        )}/email-notification/clientToAdviser?clUserId=${clUserId}&riaUserId=${riaUserId}&templateName=${templateName}`,
        payload
      );
  },
};
